import { apiClient } from "./apiClient";

export const billingService = {
    async getPlans(token) {
        return apiClient("/billing/plans", {
            token,
            method: "GET"
        });
    },

    // Renamed from subscribe to checkout
    async checkout(token, planId) {
        return apiClient("/billing/checkout", {
            token,
            method: "POST",
            body: { planId }
        });
    },

    async directUpgrade(token, planId) {
        return apiClient("/billing/upgrade-direct", {
            token,
            method: "POST",
            body: { planId }
        });
    },

    async getInvoices(token) {
        return apiClient("/billing/invoices", {
            token,
            method: "GET"
        });
    }
};
